import * as React from "react";
const EqualSmall = ({ size, ...props }) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M13 7H5v1h8V7Zm0 3H5v1h8v-1Z" }));
EqualSmall.displayName = "EqualSmall";
var EqualSmall_default = EqualSmall;
export {
  EqualSmall_default as default
};
